import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import { useState } from "react";
import { RegionUpdateForm } from "../RegionUpdateForm";
import { assertTypeName } from "../../client/guards";
import { ListFormField } from "../../attributes/list/ListFormField";
import { ListItemFormField } from "../../attributes/list-item/ListItemFormField";
import {
  ListType,
  useSublistRegionEditorSuspenseQuery,
  useUpdateSublistRegionMutation,
} from "../../client/generated";

type Props = {
  listAttributeId: string;
  listItemAttributeId: string;
  dispatch: Dispatch<EditorAction>;
};

export function SublistRegionEditor({
  listAttributeId,
  listItemAttributeId,
  dispatch,
}: Props) {
  const { data } = useSublistRegionEditorSuspenseQuery({
    variables: {
      listAttributeId,
      listItemAttributeId,
    },
  });

  const { listAttr, listItemAttr } = data;
  assertTypeName(listAttr?.__typename === "ListAttribute");
  assertTypeName(listItemAttr?.__typename === "ListItemAttribute");

  const [updateRegion] = useUpdateSublistRegionMutation();
  const [listType, setListType] = useState(listAttr.listType);
  const [ordinal, setOrdinal] = useState(listItemAttr.ordinal);

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    const result = await updateRegion({
      variables: {
        listAttributeId,
        listType,
        listItemAttributeId,
        ordinal,
      },
    });

    return (
      !result.errors &&
      !result.data?.updateListAttribute.userErrors?.length &&
      !result.data?.updateListItemAttribute.userErrors?.length
    );
  };

  return (
    <RegionUpdateForm onSubmit={onSubmit} dispatch={dispatch}>
      <ListFormField
        value={listType}
        onValueChange={(newListType: ListType) => setListType(newListType)}
      />
      <ListItemFormField
        value={ordinal}
        onChange={(event) => setOrdinal(parseInt(event.target.value))}
      />
    </RegionUpdateForm>
  );
}
